import 'owl.carousel';

export default function (obj) {
    imagesLoaded('body', function() {
        obj.find('.gallery-columns-1, .wp-block-gallery.columns-1').owlCarousel({
            rtl: herald_js_settings.rtl_mode === "true",
            loop: true,
            nav: true,
            autoWidth: false,
            autoHeight: true,
            center: false,
            fluidSpeed: 100,
            margin: 0,
            items: 1,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
        });
    });
}
